import { Container } from 'typedi'
import { MeetingRoute } from './services/meeting-route'

Container.import([
  MeetingRoute
])

export { default as InternalMeetingSearch } from './meeting-search.vue'
export { default as MeetingEditor } from './meeting-editor.vue'
